export enum PoStatus {
  DRAFT = 'draft',
  SUBMITTED = 'SMT',
  RECEIVED = 'RCV',
  PARTIALLY_RECEIVED = 'PRCV',
  SUBMITTED_TO_VENDOR = 'SMT',
  OPEN_CANCELLED = 'OC',
}
